(function (Drupal, once) {
  Drupal.behaviors.hslTabelaModal = {
    attach(context) {
      if (typeof window === "undefined") {
        return;
      }

      // Find all tabela-modal components, even if they have data-once
      // We need to process them to group items into rows
      let components = [];

      if (context.querySelectorAll) {
        components = Array.from(context.querySelectorAll(".hsl-tabela-modal"));
      }

      // Fallback: also check document if context doesn't have the elements
      if (components.length === 0) {
        components = Array.from(document.querySelectorAll(".hsl-tabela-modal"));
      }

      components.forEach((tabelaModalComponent) => {
        // Skip if already processed by this behavior
        if (tabelaModalComponent.dataset.hslTabelaModalProcessed) {
          return;
        }

        // Handle specialty-title accordion functionality
        // Check if specialty-title is inside the component or right before it
        let specialtyTitle = tabelaModalComponent.querySelector(
          ".hsl-tabela-modal__specialty-title",
        );

        // If not found inside, check if it's the previous sibling
        if (!specialtyTitle) {
          const previousSibling = tabelaModalComponent.previousElementSibling;
          if (
            previousSibling &&
            previousSibling.classList.contains(
              "hsl-tabela-modal__specialty-title",
            )
          ) {
            specialtyTitle = previousSibling;
          }
        }

        const tabela = tabelaModalComponent.querySelector(
          ".hsl-tabela-modal__tabela",
        );

        if (specialtyTitle && tabela) {
          // Add accordion functionality to specialty title
          const titleHeading = specialtyTitle.querySelector("h2, h3, h4");
          if (titleHeading) {
            // Make it clickable
            specialtyTitle.classList.add(
              "hsl-tabela-modal__specialty-title--accordion",
            );
            specialtyTitle.setAttribute("role", "button");
            specialtyTitle.setAttribute("aria-expanded", "false");
            specialtyTitle.setAttribute("tabindex", "0");

            // Hide table by default when specialty-title exists
            tabela.classList.add("hsl-tabela-modal__tabela--collapsed");

            // Toggle function
            const toggleSpecialtyAccordion = (e) => {
              e.preventDefault();
              e.stopPropagation();

              const isExpanded =
                specialtyTitle.getAttribute("aria-expanded") === "true";

              if (isExpanded) {
                // Collapse
                specialtyTitle.setAttribute("aria-expanded", "false");
                specialtyTitle.classList.remove(
                  "hsl-tabela-modal__specialty-title--expanded",
                );
                tabela.classList.add("hsl-tabela-modal__tabela--collapsed");
              } else {
                // Expand
                specialtyTitle.setAttribute("aria-expanded", "true");
                specialtyTitle.classList.add(
                  "hsl-tabela-modal__specialty-title--expanded",
                );
                tabela.classList.remove("hsl-tabela-modal__tabela--collapsed");
              }
            };

            // Add click event
            specialtyTitle.addEventListener("click", toggleSpecialtyAccordion);

            // Add keyboard support (Enter and Space)
            specialtyTitle.addEventListener("keydown", (e) => {
              if (e.key === "Enter" || e.key === " ") {
                toggleSpecialtyAccordion(e);
              }
            });
          }
        }

        if (!tabela) return;

        // Skip if already processed (has rows)
        if (tabela.querySelector(".hsl-tabela-modal__row")) {
          tabelaModalComponent.dataset.hslTabelaModalProcessed = "true";
          return;
        }

        // Mark as being processed
        tabelaModalComponent.dataset.hslTabelaModalProcessed = "true";

        // Don't create divs inside ul - keep li elements as they are
        // Just add zebra classes and associate modals with rows via data attributes

        // Find all th items (headers) to get column labels
        const allThItems = Array.from(
          tabela.querySelectorAll(":scope > .hsl-tabela-modal__th"),
        );

        // Extract column labels from th elements
        const columnLabels = allThItems.map((th) => {
          const span = th.querySelector("span");
          return span ? span.textContent.trim() : "";
        });

        // Find all td items that are direct children of the ul
        const allTdItems = Array.from(
          tabela.querySelectorAll(":scope > .hsl-tabela-modal__td"),
        );

        // Group td items in sets of 3 (zebra, accordion, column labels)
        for (let i = 0; i < allTdItems.length; i += 3) {
          const group = allTdItems.slice(i, i + 3);
          const rowIndex = Math.floor(i / 3);

          if (group.length === 3) {
            // Add column labels as data attributes for mobile display
            group.forEach((td, colIndex) => {
              if (columnLabels[colIndex]) {
                // Add to td
                td.dataset.columnLabel = columnLabels[colIndex];
                // Also add to span inside td for CSS ::before
                const span = td.querySelector("span");
                if (span) {
                  span.dataset.columnLabel = columnLabels[colIndex];
                }
              }
            });

            // Add zebra class to tds (second, fourth, sixth... rows get background)
            if (rowIndex % 2 === 1) {
              group.forEach((td) => {
                td.classList.add("hsl-tabela-modal__td--zebra");
              });
            }

            // Add hover effect for grid mode
            // When hovering a td, apply hover class to all tds in the same row group
            group.forEach((td) => {
              td.addEventListener("mouseenter", () => {
                group.forEach((otherTd) => {
                  otherTd.classList.add("hsl-tabela-modal__td--hover");
                });
              });

              td.addEventListener("mouseleave", () => {
                group.forEach((otherTd) => {
                  otherTd.classList.remove("hsl-tabela-modal__td--hover");
                });
              });
            });

            // Accordion functionality: first item expands/collapses other items on mobile
            const firstItem = group[0];
            const otherItems = group.slice(1); // Items 2 and 3

            if (firstItem && otherItems.length > 0) {
              // Mark first item as accordion trigger
              firstItem.classList.add(
                "hsl-tabela-modal__td--accordion-trigger",
              );
              firstItem.setAttribute("aria-expanded", "false");
              firstItem.setAttribute("role", "button");
              firstItem.setAttribute("tabindex", "0");

              // Mark other items as accordion content
              otherItems.forEach((item) => {
                item.classList.add("hsl-tabela-modal__td--accordion-content");
              });

              // Toggle function
              const toggleAccordion = (e) => {
                // Only work on mobile (below md breakpoint)
                if (window.innerWidth >= 768) {
                  return;
                }

                e.preventDefault();
                e.stopPropagation();

                const isExpanded =
                  firstItem.getAttribute("aria-expanded") === "true";

                if (isExpanded) {
                  // Collapse
                  firstItem.setAttribute("aria-expanded", "false");
                  firstItem.classList.remove(
                    "hsl-tabela-modal__td--accordion-expanded",
                  );
                  otherItems.forEach((item) => {
                    item.classList.remove(
                      "hsl-tabela-modal__td--accordion-expanded",
                    );
                  });
                } else {
                  // Expand
                  firstItem.setAttribute("aria-expanded", "true");
                  firstItem.classList.add(
                    "hsl-tabela-modal__td--accordion-expanded",
                  );
                  otherItems.forEach((item) => {
                    item.classList.add(
                      "hsl-tabela-modal__td--accordion-expanded",
                    );
                  });
                }
              };

              // Add click event
              firstItem.addEventListener("click", toggleAccordion);

              // Add keyboard support (Enter and Space)
              firstItem.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  toggleAccordion(e);
                }
              });
            }
          }
        }

        // Find all "Mais detalhes" links or text in table rows
        // They might be links or just text spans that need to be made clickable
        const detalhesElements = tabelaModalComponent.querySelectorAll(
          ".hsl-tabela-modal__td a, .hsl-tabela-modal__td span",
        );

        detalhesElements.forEach((element) => {
          // Check if it's the "Mais detalhes" text (link or span)
          const text = element.textContent.trim().toLowerCase();
          if (!text.includes("detalhes") && !text.includes("mais")) {
            return;
          }

          // Make it clickable if it's not already a link
          if (element.tagName !== "A") {
            element.setAttribute("data-detalhes-clickable", "true");
            element.classList.add("hsl-tabela-modal__detalhes-clickable");
          }

          // Find the parent td first
          const parentTd = element.closest(".hsl-tabela-modal__td");
          if (!parentTd) return;

          // Find the modal by DOM proximity: next sibling(s) until .hsl-tabela-modal__modal
          let modal = null;
          let node = parentTd.nextElementSibling;
          const tabelaList = parentTd.parentElement;

          while (node && node.parentElement === tabelaList) {
            if (node.classList.contains("hsl-tabela-modal__modal")) {
              modal = node;
              break;
            }
            node = node.nextElementSibling;
          }

          if (!modal) {
            console.warn(
              "HSL Tabela Modal: Modal not found for element",
              element,
            );
            return;
          }

          element.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Check if modal is using Site Studio modal system
            const siteStudioModal = modal.querySelector(
              ".coh-modal, .a11y-modal",
            );

            if (siteStudioModal) {
              // Use Site Studio modal trigger if available
              const triggerButton =
                siteStudioModal.querySelector("[data-modal-open]");
              if (triggerButton) {
                triggerButton.click();
                return;
              }

              // Fallback: manually show modal
              siteStudioModal.classList.add("is-open");
              document.body.classList.add("hsl-modal-open");
            } else {
              // Custom modal implementation
              // Check if modal already has overlay structure
              let overlay = modal.parentElement;
              if (
                !overlay ||
                !overlay.classList.contains("coh-modal-overlay")
              ) {
                // Create overlay wrapper if it doesn't exist
                overlay = document.createElement("div");
                overlay.className = "coh-modal-overlay hsl-modal-overlay";

                // Wrap modal in overlay
                modal.parentElement.insertBefore(overlay, modal);
                overlay.appendChild(modal);
              }

              // Show modal
              overlay.classList.add("hsl-modal-overlay--visible");
              modal.classList.add("hsl-tabela-modal__modal--visible");
              document.body.classList.add("hsl-modal-open");

              // Close on overlay click
              overlay.addEventListener(
                "click",
                function closeOnOverlayClick(e) {
                  if (e.target === overlay) {
                    overlay.classList.remove("hsl-modal-overlay--visible");
                    document.body.classList.remove("hsl-modal-open");
                    overlay.removeEventListener("click", closeOnOverlayClick);
                  }
                },
              );
            }
          });
        });

        // Add close button to each modal before the title
        const modals = tabelaModalComponent.querySelectorAll(
          ".hsl-tabela-modal__modal",
        );

        modals.forEach((modal) => {
          // Check if close button already exists
          const existingCloseButton = modal.querySelector(
            ".coh-modal-close-button",
          );
          if (existingCloseButton) {
            return;
          }

          // Find the title element (h3 or element with __titulo class)
          const titulo = modal.querySelector(
            ".hsl-tabela-modal__modal__titulo, h3",
          );

          if (titulo) {
            // Create close button
            const closeButton = document.createElement("button");
            closeButton.className = "coh-modal-close-button";
            closeButton.type = "button";
            closeButton.setAttribute("aria-label", "Fechar modal");

            // Insert before title
            titulo.parentElement.insertBefore(closeButton, titulo);
          }
        });

        // Handle modal close buttons
        const closeButtons = tabelaModalComponent.querySelectorAll(
          ".coh-modal-close-button, [data-modal-close-btn]",
        );

        closeButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Find the modal (could be hsl-tabela-modal__modal or inside overlay)
            let modal = button.closest(".hsl-tabela-modal__modal");
            if (!modal) {
              modal = button.closest(".coh-modal, .a11y-modal");
            }

            if (modal) {
              // Remove visible classes
              modal.classList.remove("hsl-tabela-modal__modal--visible");
              modal.classList.remove("is-open");

              // Find and hide overlay
              const overlay = modal.closest(".coh-modal-overlay");
              if (overlay) {
                overlay.classList.remove("hsl-modal-overlay--visible");
              }

              // Remove body class
              document.body.classList.remove("hsl-modal-open");
            }
          });
        });

        // Close modal when clicking overlay
        const overlays =
          tabelaModalComponent.querySelectorAll(".coh-modal-overlay");

        overlays.forEach((overlay) => {
          overlay.addEventListener("click", (e) => {
            if (e.target === overlay) {
              const modal = overlay.closest(".coh-modal, .a11y-modal");
              if (modal) {
                modal.classList.remove("is-open");
                document.body.classList.remove("hsl-modal-open");
              }
            }
          });
        });

        // Close modal when clicking "Ok, entendi" button
        const okButtons = tabelaModalComponent.querySelectorAll(
          ".hsl-tabela-modal__botoes .coh-button, .hsl-tabela-modal__botoes button",
        );

        okButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            // Only close if it's the "Ok, entendi" button, not the link button
            if (
              button.textContent.trim().toLowerCase().includes("entendi") ||
              button.textContent.trim().toLowerCase().includes("ok")
            ) {
              e.preventDefault();
              e.stopPropagation();

              // Find the modal - could be Site Studio modal or custom modal
              let modal = button.closest(".coh-modal, .a11y-modal");

              if (modal) {
                // Site Studio modal
                modal.classList.remove("is-open");
                document.body.classList.remove("hsl-modal-open");
              } else {
                // Custom modal - find the overlay
                const modalContainer = button.closest(
                  ".hsl-tabela-modal__modal",
                );
                if (modalContainer) {
                  const overlay = modalContainer.closest(".coh-modal-overlay");
                  if (overlay) {
                    overlay.classList.remove("hsl-modal-overlay--visible");
                    document.body.classList.remove("hsl-modal-open");
                  } else {
                    // Fallback: hide modal directly
                    modalContainer.classList.remove(
                      "hsl-tabela-modal__modal--visible",
                    );
                    document.body.classList.remove("hsl-modal-open");
                  }
                }
              }
            }
          });
        });
      });
    },
  };
})(Drupal, once);
